/**
 * Bread sidebar rotator
 */

export default {

	/**
	 * Initialization
	 */
	init() {
		const hoverTargets = document.querySelectorAll('.rotator-overlay span');
		const rotator = document.querySelectorAll('.rotator');

		[...hoverTargets].forEach(el => {
			el.addEventListener('mouseover', e => this.hover(e.currentTarget));
		});

		[...rotator].forEach(el => {
			el.addEventListener('mouseleave', e => this.reset(e.currentTarget));
		});
	},

	/**
	 * Handle overlay target section hover
	 *
	 * @param {Node} el target element
	 */
	hover(el) {
		const rotator = el.parentNode.parentNode;
		const index = el.dataset.index;

		rotator.querySelector('.active').classList.remove('active');
		rotator.querySelectorAll('img')[index].classList.add('active');
	},

	/**
	 * Reset the rotator to its original state
	 *
	 * @param {Node} el target rotator element
	 */
	reset(el) {
		el.querySelector('.active').classList.remove('active');
		el.querySelector('img:first-child').classList.add('active');
	},
}